import { booleanPointInPolygon } from "@turf/turf";
import { courseMapElementLimit } from "json/constants";

const isPlacedCoordinate = (value) =>
  Number.isFinite(value) && value !== 0 && value !== -1;

export const collectTeeboxCenters = (gpsHole) => {
  const centers = [];
  if (!gpsHole) {
    return centers;
  }
  for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
    const lat = gpsHole[`teeLat${i}`];
    const lon = gpsHole[`teeLon${i}`];
    if (isPlacedCoordinate(lat) && isPlacedCoordinate(lon)) {
      centers.push([lat, lon]);
    }
  }
  return centers;
};

export const findTeeboxWithoutCenter = (teeboxList, teeCenters) => {
  const teeboxes = teeboxList ?? [];
  const centers = teeCenters ?? [];
  for (const teebox of teeboxes) {
    const ring = teebox?.list?.[0];
    if (!Array.isArray(ring) || ring.length < 4) {
      continue;
    }
    const polygon = { type: "Polygon", coordinates: [ring] };
    const hasCenterInside = centers.some((center) =>
      booleanPointInPolygon(center, polygon)
    );
    if (!hasCenterInside) {
      return teebox;
    }
  }
  return null;
};
